export default "__VITE_ASSET__BqHjetlV__"